import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ExtrasIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19.965 15.37a3.382 3.382 0 01-3.39-3.39c0-.9.35-1.75.99-2.4 1.28-1.28 3.51-1.28 4.79 0 .64.64.99 1.49.99 2.4 0 .91-.36 1.76-.99 2.4-.63.64-1.49.99-2.4.99h.01zm0-4.78c-.37 0-.72.14-.98.41-.26.26-.41.62-.41.98s.15.72.41.98c.52.52 1.44.53 1.96 0 .26-.26.41-.62.41-.98a1.403 1.403 0 00-1.39-1.39zm-7.96 4.78c-.91 0-1.76-.35-2.4-.99a3.407 3.407 0 010-4.8c1.28-1.28 3.51-1.28 4.79 0 .64.64.99 1.49.99 2.4 0 .91-.36 1.76-.99 2.4-.63.64-1.49.99-2.4.99h.01zm0-4.78c-.37 0-.72.14-.98.41-.26.27-.41.61-.41.98s.15.72.41.98c.53.53 1.44.53 1.96 0 .26-.26.41-.62.41-.98a1.403 1.403 0 00-1.39-1.39zm-7.96 4.78c-.91 0-1.76-.35-2.4-.99-.63-.63-.99-1.5-.99-2.4 0-.9.35-1.75.99-2.39 1.28-1.28 3.51-1.28 4.79 0 .64.64.99 1.49.99 2.4 0 .91-.36 1.77-.99 2.4-.64.64-1.49.99-2.4.99l.01-.01zm0-4.78c-.37 0-.72.14-.98.41-.26.27-.41.61-.41.98s.15.72.41.98c.53.53 1.44.53 1.96 0 .26-.26.41-.62.41-.98s-.14-.72-.41-.98c-.26-.26-.61-.41-.98-.41z"
                    })
                })
            })
        ]
    });
};
ExtrasIcon.isCarinaIcon = true;
export default ExtrasIcon;
